import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class NewMachineDetail extends Component {
  state = {
    pageTitle: "Makine Detay",
    pageTitleDetail: "Makine Detay",
    pageAddLink: "yeni-makine-ekle",
    pageListLink: "yeni-makine-listele",
    breadcrumb: [{ text: "Makine", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    machineModelName: "",
    machineStatusName: "",
    bmb: "",
    serialNo: "",
    name: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/newMachines/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            name: response.data.name,
            bmb: response.data.bmb,
            serialNo: response.data.serialNo,
            machineModelName: response.data.machineModelName,
            machineStatusName: response.data.machineStatusName,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>İsim</th>
                    <td colSpan="4">
                      {this.state.name}
                    </td>
                  </tr>

                  <tr>
                    <th>Model</th>
                    <td colSpan="4">
                      {this.state.machineModelName
                        ? this.state.machineModelName
                        : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Seri No</th>
                    <td colSpan="4">
                      {this.state.serialNo ? this.state.serialNo : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>C4C</th>
                    <td colSpan="4">
                    {this.state.bmb ? this.state.bmb : "-"}
                    </td>
                  </tr>

                 
                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">{this.state.machineStatusName}</td>
                  </tr>


                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default NewMachineDetail;
